import { render, staticRenderFns } from "./MendingAutobuyerBox.vue?vue&type=template&id=76ac2332&scoped=true&"
import script from "./MendingAutobuyerBox.vue?vue&type=script&lang=js&"
export * from "./MendingAutobuyerBox.vue?vue&type=script&lang=js&"
import style0 from "./MendingAutobuyerBox.vue?vue&type=style&index=0&id=76ac2332&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ac2332",
  null
  
)

export default component.exports